import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { Point } from 'pixi.js';
import { AnimationContents } from '../../../AnimationContents';
import { ButtonController, IButtonControllerOptions } from '../../Common/ButtonController';
import { GameStateEnum } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { ShopSmallCardController } from './ShopLife/ShopSmallCardController';
import { ShopModel } from '../../Models/ShopModel';
import { ModalsNames } from '../../Common/MadalsManager/ModalsList';


export interface IShopLifeScreenControllerOptions {
}

export class ShopLifeScreenController extends AnimationBaseController {
    $model: ShopModel;
    _width: number;

    public constructor(
        @Inject private _options: IShopLifeScreenControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('ShopLifeScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        const cards = {};
        this.$model.lifeShopItems.forEach((productModel, i) => {
            cards[`item${i + 1}`] = {
                instanceName: `content.item${i + 1}`,
                controller: ShopSmallCardController,
                model: productModel,
            };
        });

        return {
            animationContent: AnimationContents.SHOP_LIFE_SCREEN_JSON,
            libraryName: 'shop_life',
            childControllers: {
                btn_exit: {
                    instanceName: 'btn_exit',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            this._gameLogic.modalsManager.hide();
                        },
                    },
                },
                ...cards,
            },
        };
    }

    protected onInitialize() {
        this._width = this.width;
    }

    protected onResize(width: number, height: number, scale: number) {
        const margin = 20;

        const topLeftPoint = this.display.toLocal(new Point(0, 0), this.renderer.stage);
        const bottomRightPoint = this.display.toLocal(new Point(width, height), this.renderer.stage);

        const btn_exit = this.$childControllers.get('btn_exit').display;
        btn_exit.x = bottomRightPoint.x - btn_exit.width / 2 - margin;
        btn_exit.y = topLeftPoint.y + btn_exit.height / 2 + margin;
    }
}
